import React, { useMemo } from 'react';
import StarRating from '../../../../../components/shared/StarRating';
import { string, shape } from 'prop-types';
import { timeAgo } from '../../../../../utils/time_helpers';
import styles from './styles/styles.module.scss';
import UserLabel from '../../UserLabel';
import FeedItemDescription from '../../FeedItemDescription';

const FeedItemWrapper = ({ user, timestamp, description, context, starRating, children }) => {
  const subText = useMemo(() => {
    return timeAgo(timestamp, context.languageRegionCode);
  }, []);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.userAndDescription}>
          <UserLabel
            context={context}
            name={`${user.firstName} ${user.lastName}`}
            subText={subText}
            userLink={user.links[0].href}
            profileImageUrl={user.profilePhoto.href}
          />
          <div className={styles.feedItemDescription}>
            <FeedItemDescription __html={description} />
            {starRating && (
              <span className={styles.starSpacer}>
                <StarRating config={starRating} />
              </span>
            )}
          </div>
        </div>
        {children}
      </div>
      <div className={styles.bottomBorder} />
    </>
  );
};

FeedItemWrapper.propTypes = {
  user: shape({
    firstName: string,
    lastName: string,
    profilePhoto: shape({
      href: string
    })
  }).isRequired,
  timestamp: string.isRequired
};

export default FeedItemWrapper;
